/* globals BaseUrl */
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { isStaticRender } from 'helpers/ContentHelper';
import { fetchFooter } from 'components/Footer/FooterActions';
import { breadcrumbsSeriesDetailParser } from 'components/Breadcrumbs';
import { fetchCategoryDetail } from './PersonalityActions';
import Social from '../../components/Social';

const FETCH_NEW_CONTENT_INTERVAL_MS = 1000 * 60 * 30;
const PANEL_TYPE_PERSON_BRANDING = 'personBranding';

const isShowComponent = elem =>
  (elem && elem.panelType === 'shows') || elem['@type'] === 'ShowPanel';

const getDetailData = ({ data }) => {
  let faq = null;
  let socials = null;
  const panels = data?.panels?.member;
  const showComponents = panels.filter(elem => isShowComponent(elem));
  const favoritableItems = data?.favoritableItems ?? null;

  const bio =
    panels.filter(section => section?.panelType === PANEL_TYPE_PERSON_BRANDING)[0]?.items
      ?.member[0] ?? null;
  if (bio) {
    faq = transformFaq(bio?.faq ?? []);
    socials = {
      twitter: bio?.twitterId ?? null,
      facebook: bio?.facebookId ?? null,
      instagram: bio?.instagramId ?? null,
    };
  }
  let seo = data?.SEO ?? {};
  const autoGeneratedSEO = generateSEO({ seriesData: data, socials });
  seo = { ...autoGeneratedSEO, ...seo };

  return {
    bio,
    collections: showComponents,
    faq,
    favoritableItems,
    seo,
    socials,
  };
};

const fetchInitialData = ({ accessToken, showId, deviceId, intervalFetch, dispatch }) => {
  if (isStaticRender()) return null;

  dispatch(fetchCategoryDetail(showId, accessToken, deviceId)).then(() => dispatch(fetchFooter()));
  return setInterval(() => {
    // TODO: confirm latest accesstoken is used
    intervalFetch();
  }, FETCH_NEW_CONTENT_INTERVAL_MS);
};

const getBreadcumbsData = ({ params, seriesData, headline }) =>
  breadcrumbsSeriesDetailParser(params, seriesData, null, null, true, headline);

const getSocialLinksFromIds = ({ facebookId = '', instagramId = '', twitterId = '' }) => {
  const socialLinks = [];
  if (facebookId) {
    socialLinks.push({
      alt: `facebook.com/${facebookId}`,
      link: `https://www.facebook.com/${facebookId}`,
      logo: <Social brand="facebook" color="white" />,
      text: `@${facebookId}`,
    });
  }
  if (instagramId) {
    socialLinks.push({
      alt: `instagram.com/${instagramId}`,
      link: `https://www.instagram.com/${instagramId}`,
      logo: <Social brand="instagram" color="white" />,
      text: `@${instagramId}`,
    });
  }
  if (twitterId) {
    socialLinks.push({
      alt: `twitter.com/${twitterId}`,
      link: `https://twitter.com/${twitterId}`,
      logo: <Social brand="twitter" color="white" />,
      text: `@${twitterId}`,
    });
  }
  return socialLinks;
};

const generateSEO = ({ seriesData, socials }) => {
  const personalityName = seriesData?.name;
  const title = `${personalityName} on Fox Nation`;
  const description = `Explore  ${personalityName} on Fox Nation. Discover the latest and most trending news for ${personalityName}. Watch full episodes and extra features and more online.`;
  const seriesListImage = seriesData?.images?.seriesList?.raw;
  const personUrl = `${BaseUrl}/${seriesData?.id}`;
  const personImage = seriesData?.autoPlayStill?.default?.url;
  return {
    canonicalUrl: personUrl,
    description,
    ogDescription: description,
    ogImage: `${seriesListImage}?fit=inside%7C320:180`,
    ogSiteName: title,
    ogTitle: title,
    ogType: 'website',
    ogUrl: personUrl,
    siteName: 'Fox Nation',
    title,
    twitterCard: 'summary',
    twitterCardType: 'summary',
    twitterDescription: description,
    twitterImage: `${personImage}?fit=inside%7C480:270`,
    twitterSite: socials?.twitter,
    twitterTitle: title,
    twitterUrl: personUrl,
  };
};

const transformFaq = (faqs = []) => faqs?.map(item => ({ ...item, id: uuidv4() }));

export { getDetailData, fetchInitialData, getBreadcumbsData, getSocialLinksFromIds };
